import { AnalysisAttributes, Card } from 'components'
import { Box, Divider, Typography } from '@mui/material'
import { Delivery } from '../../../../../../types'

interface AnalysisParametersProps {
  delivery?: Delivery
  binName?: string
}

const dividerStyles = {
  alignSelf: 'center',
  width: '100%',
}

export function AnalysisParameters({
  delivery,
  binName,
}: AnalysisParametersProps) {
  return (
    <Card
      display="flex"
      flex={1}
      flexDirection="column"
      padding="0px 16px 20px 16px"
      gap={'22px'}
    >
      <AnalysisAttributes
        attributes={delivery?.attributes}
        defaultWheatCodeAttributes={delivery?.wheat_code?.attributes}
      />
      <Divider orientation="horizontal" flexItem sx={dividerStyles} />
      <Box display={'flex'} alignItems="center">
        <Typography fontSize="18px" fontWeight="800">
          Storage:
        </Typography>
        <Typography fontSize="18px" ml="5px">
          {binName}
        </Typography>
      </Box>
    </Card>
  )
}
